import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '../../core';
import { BOOTSTRAP_FORMLY_CONFIG, FIELD_TYPE_COMPONENTS } from './ui-bootstrap.config';
import { FormlyValidationMessage } from './formly.validation-message';
var FormlyBootstrapModule = (function () {
    function FormlyBootstrapModule() {
    }
    return FormlyBootstrapModule;
}());
FormlyBootstrapModule = tslib_1.__decorate([
    NgModule({
        declarations: FIELD_TYPE_COMPONENTS.concat([FormlyValidationMessage]),
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormlyModule.forRoot(BOOTSTRAP_FORMLY_CONFIG),
        ],
    })
], FormlyBootstrapModule);
export { FormlyBootstrapModule };
//# sourceMappingURL=ui-bootstrap.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/ui-bootstrap.module.js
// module id = 780
// module chunks = 3